import React, { useState, useEffect } from "react";
import "./styles.css";

const sipData = new Array(100)
  .fill("")
  .map((e, i) => ({ price: 16 + i, quantity: 200 + i }));

const SipLine = ({ tickDuration }) => {
  const [left, setLeft] = useState(-775);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (tickDuration) {
      setLeft(-775);
      setReset(true);
    }
  }, [tickDuration]);

  useEffect(() => {
    if (left === -775 && reset) {
      setTimeout(() => {
        setLeft(-775 - 140 * sipData.length);
        setReset(false);
      }, 20);
    }
  }, [left, reset]);

  return (
    <div className="streams-streamline__wrapper sip-wrapper">
      <div
        className="streams-streamline__innerwrapper"
        style={{
          transform: `translateX(${left}px)`,
          transition: `transform ${left !== -775 ? tickDuration * sipData.length : 0
            }ms linear`
        }}
      >
        {[<div key={"SipLine-first-item"} style={{ width: 772 }} />].concat(
          sipData?.map((item, index) => (
            <div
              key={`${item.quantity} - ${item.price}-${index}`}
              className="streamline-item"
            >{`${item.quantity} - ${item.price}`}</div>
          ))
        )}
      </div>
    </div>
  );
};

export default SipLine;